import { Component, Inject, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { UserPromptService } from '../../../services/user-prompt.service';
import { DashboardService } from '../../../services/shared/dashboard.service';
import { ApproveSuccessComponent } from '../../../approve-success/approve-success.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-approve-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule],
  templateUrl: './approve-prompt.component.html',
  styleUrl: './approve-prompt.component.scss'
})
export class ApprovePromptComponent {
  message: string = ""
  title: string = ""
  action: string = ""
  actionType: string = "add"
  cancelButtonText = "Cancel"
  promptUserDetails: any;
  userid: any;
  user_role: any;
  is_chain:boolean=false;
  is_version:boolean=false;
  current_version:number=0;
  is_variant:boolean=false;
  current_variant:number=0;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ApprovePromptComponent>,private userPromptService: UserPromptService, private dialog: MatDialog, private dashboardService : DashboardService, private router : Router) {
    if (data) {
      this.promptUserDetails = data;
    
      this.action = data.actionType;
       if(this.promptUserDetails.prompt_type == 'chain' ){
        this.is_chain=true;
       }
       if(this.promptUserDetails.version>0){
          this.is_version=true;
          this.current_version=this.promptUserDetails.version;
       }else if (this.promptUserDetails.variant>0){
        this.is_variant=true;
        this.current_variant=this.promptUserDetails.variant;
     }
    }
    //this.dialogRef.updateSize('300vw', '300vw')
  }
  async ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onPublish() {
    let promptDetailsData: { prompt_detail_id: any; prompt_name: any; prompt: any; model_id: any; order_number: any; attachments: any; variables: any; }[] = [];
    this.promptUserDetails.prompt_details.forEach((data: any ) => {
      promptDetailsData.push({
        "prompt_detail_id":data?.prompt_detail_id,
        "prompt_name": data?.prompt_name,
        "prompt":  data?.prompt,
        "model_id":  data?.llm?.model_id ?? null,
        "order_number":  data.order_number,
        "attachments":  data.attachments,
        "variables": data.variables,
      })
      
    });
    let request = {
      "prompt": {
        "prompt_id": this.promptUserDetails?.prompt_id,
        "title": this.promptUserDetails?.title,
        "description": this.promptUserDetails?.description,
        "notes":this.promptUserDetails?.notes,
        "category_id": this.promptUserDetails.category?.category_id,
        "created_by": this.promptUserDetails?.created_by?.created_by ,
        "sub_category_id": this.promptUserDetails?.sub_category?.sub_category_id ?  this.promptUserDetails?.sub_category?.sub_category_id : null,
        "prompt_type":this.promptUserDetails.prompt_type,
        "prompt_details": promptDetailsData,
        "source_prompt_id" : this.promptUserDetails?.source_prompt_id,

      },
      "rejection_reason": "",
      "status": "PUBLISHED",
      "user_id": +this.userid
    }
    this.userPromptService.approvePrompt(request).subscribe(res => {
      let messageData;
      const variant = this.data?.variant;
      const version = this.data?.version;
      const promptTitle = this.promptUserDetails?.title;
      if (promptDetailsData && promptDetailsData.length > 1) {
        // messageData = `The prompt chain '${this.promptUserDetails?.title}' has been approved and published successfully`
        messageData = `The prompt chain `;
        if ((variant >= 1) && (version >= 1)) {
          messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
        } else if ((variant >= 1) && (version < 1)) {
          messageData += `'${promptTitle} - Variant ${variant}'`;
        } else if ((version >= 1 && (variant < 1))) {
          messageData += `'${promptTitle} - Version ${version}'`;
        } else {
          messageData += `'${promptTitle}'`;
        }
        messageData += ' has been approved and published successfully';
      } else if(promptDetailsData && promptDetailsData.length == 1) {
        // messageData = `The prompt '${this.promptUserDetails?.title}' has been approved and published successfully`
        messageData = `The prompt `;
        if ((variant >= 1) && (version >= 1)) {
          messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
        } else if ((variant >= 1) && (version < 1)) {
          messageData += `'${promptTitle} - Variant ${variant}'`;
        } else if ((version >= 1 && (variant < 1))) {
          messageData += `'${promptTitle} - Version ${version}'`;
        } else {
          messageData += `'${promptTitle}'`;
        }
        messageData += ' has been approved and published successfully';
      }
      const dialogRef = this.dialog.open(ApproveSuccessComponent, {
        data: {
          message: messageData,
          title: "Approved successfully",
          action_type: 'add'
        }
      });
    });
    this.dialogRef.close(true);
    this.router.navigateByUrl('/home/dashboard');
  }

}
